import React, { useEffect, useState } from 'react';
import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import { throttle } from 'lodash';
import NuiHeader from 'nike-ui/src/components/nui-header/NuiHeader';
import i18n from '@i18n';
import betbookNuiHeader from 'nike-ui/src/assets/img/betbook-nui-header.png';
import BetbookNavBar from '@/betbook/views/BetbookNavBar';
import { COMMUNITY_CHAT } from '@/routing/routes';

export function CommunityHeader({ active }) {
    const [topMenuShadowDisabled, setTopMenuShadowDisabled] = useState(false);

    useEffect(() => {
        const handleBetbookHeaderScroll = throttle(() => {
            if (window.scrollY >= 150 && !topMenuShadowDisabled) {
                setTopMenuShadowDisabled(true);
            }
            if (window.scrollY < 150 && topMenuShadowDisabled) {
                setTopMenuShadowDisabled(false);
            }
        }, 100);

        window.addEventListener('scroll', handleBetbookHeaderScroll);

        return () => {
            window.removeEventListener('scroll', handleBetbookHeaderScroll);
        };
    }, [topMenuShadowDisabled]);

    return (
        <>
            {/* @ts-expect-error typescript */}
            <UserBoardHeader noShadow={topMenuShadowDisabled} pageFixerClassName="bb" />
            {active !== COMMUNITY_CHAT && (
                <NuiHeader
                    title={i18n('betbook.nui.header.title')}
                    subTitle={i18n('betbook.nui.header.subtitle')}
                    iconBackground={betbookNuiHeader}
                />
            )}
            <BetbookNavBar active={active} />
        </>
    );
}
